import { render, staticRenderFns } from "./EditLotto.vue?vue&type=template&id=63221dd2&"
import script from "./EditLotto.vue?vue&type=script&lang=js&"
export * from "./EditLotto.vue?vue&type=script&lang=js&"
import style0 from "./EditLotto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports